import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=1a305f23&scoped=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=1a305f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a305f23",
  null
  
)

export default component.exports